import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { TranslateLoader, } from '@ngx-translate/core';
import { TranslationService } from '@services';
export function createTranslateLoader(http, appState) {
    return new TranslationService(http, appState);
}
var ɵ0 = (createTranslateLoader);
export var TRANSLATE_MODULE_CONFIG = {
    loader: {
        provide: TranslateLoader,
        useFactory: ɵ0,
        deps: [HttpClient, AppStateFacade],
    },
};
export { ɵ0 };
